export default {
  getChecklistTemplate: (state) => state.checklistTemplate,
};
